import React from 'react';
import { Link } from 'react-router-dom';
import './CourseSection.css';

const CourseSection = () => {
  const courses = [
    {
      title: 'Defense Coaching',
      subtitle: 'NDA, CDS, AFCAT, RIMC, RMS, Sainik Schools',
      image: '/images/DEFENCE.png'
    },
    {
      title: 'Defence Entry Programs',
      subtitle: 'Agniveer, NCC Cadets, Military Police',
      image: '/images/Learning-amico.png'
    },
    {
      title: 'Engineering & Medical',
      subtitle: 'JEE (Main & Advanced), NEET',
      image: '/images/Vaccine development-amico.png'
    },
    {
      title: 'Law & University Exams',
      subtitle: 'CLAT, CUET, MHTCET',
      image: '/images/Webinar-amico.png'
    },
    {
      title: 'SSB Training',
      subtitle: 'Service Selection Board Preparation',
      image: '/images/college class-amico.png'
    },
    {
      title: 'MEAP Framework',
      subtitle: 'Maths, English, Aptitude, Psychology',
      image: '/images/COMPETITIVE.png'
    }
  ];

  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const displayedCourses = isMobile ? courses.slice(0, 2) : courses;

  return (
    <section className="course-section">
      <div className="course-container">
        <div className="course-title-wrapper">
          <div className="title-background">COURSES</div>
          <div className="course-title-container">
            <h2 className="course-title">
              <span className="title-our">Our</span>
              <span className="title-courses">Courses</span>
            </h2>
          </div>
        </div>
        <p className="title-subtitle">Comprehensive preparation for defense and competitive exams</p>
        <div className="course-grid">
          {displayedCourses.map((course, index) => (
            <div key={index} className="course-card">
              <div className="course-image-container">
                <img src={course.image} alt={course.title} className="course-image" />
              </div>
              <div className="course-info">
                <h3>{course.title}</h3>
                <p className="course-subtitle">{course.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
        <Link 
          to="/competitive-exams" 
          className="view-all-button"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
              window.location.href = '/competitive-exams';
            }, 500);
          }}
        >
          View All Courses
        </Link>
      </div>
    </section>
  );
};

export default CourseSection;
